import { defineMessages } from 'react-intl';

const messages = defineMessages({
  page_heading: {
    defaultMessage: "Discover Instana's value to your business",
    id: 'J52GK8',
  },
  page_heading_2: {
    id: 'gFdjNK',
    defaultMessage:
      'Please answer these questions to assess Instana’s business value to your organization',
  },
  question_1: {
    id: 'skLUxX',
    defaultMessage:
      'How many major application disruptions do you experience per month?',
  },
  question_2: {
    id: 'wEqD1y',
    defaultMessage:
      'On average how much time is spent resolving each major disruption?',
  },
  options_1: {
    id: 'G3wLIB',
    defaultMessage: 'Less than 30 mins ',
  },
  options_2: {
    id: 'jfya0B',
    defaultMessage: '30-90 mins',
  },
  options_3: {
    id: 'j9Y9nu',
    defaultMessage: 'Hours',
  },
  options_4: {
    id: 'gEX47n',
    defaultMessage: 'Days+',
  },
  question_3: {
    id: 'LqDpki',
    defaultMessage: 'How many developers are in your organization?',
  },
  question_4: {
    id: 'pM8k05',
    defaultMessage: 'How many IT Ops employees do you have in your team?',
  },
  question_5: {
    id: 'aF3N4M',
    defaultMessage: 'Do you use any of the following OpenSource technologies?',
  },
  checkbox_1: {
    id: 'AMCq17',
    defaultMessage: 'Prometheus',
  },
  checkbox_2: {
    id: 'JIl4AY',
    defaultMessage: 'Jaeger',
  },
  checkbox_3: {
    id: 'dYlenA',
    defaultMessage: 'OpenTelemetry',
  },
  checkbox_4: {
    id: 'PJCW+V',
    defaultMessage: 'Zipkin',
  },
  checkbox_5: {
    id: 'IHrK1D',
    defaultMessage: 'OpenTracing',
  },
  checkbox_6: {
    id: 'LMr8Q3',
    defaultMessage: 'OpenCensus',
  },
  bva_results: {
    id: 'FGu7c1',
    defaultMessage: 'View the business value results',
  },
  reset: {
    id: 'jm/spn',
    defaultMessage: 'Reset',
  },
  footnote_1: {
    id: '/1BWun',
    defaultMessage:
      'Estimated price is not a formal offer from IBM or an IBM Business Partner. Certain factors such as Planning Analytics with Watson configuration, add-ons, and discounts may affect final price. IBM Business Partners set and provide their own Planning Analytics with Watson pricing, and neither IBM nor IBM Business Partners are bound by the provided price configuration. Your quoted price will likely vary. Minimum term is 12 month. Price configuration tool does not apply to Planning Analytics as a Service offering.',
  },
  page_heading_3: {
    id: 'sgqfrx',
    defaultMessage: "Instana's value to your business",
  },
  page_heading_4: {
    id: 'D3K6DO',
    defaultMessage: 'Estimated Reduced application disruptions',
  },
  label_1: {
    id: 'TM3M8Y',
    defaultMessage: '# of prevented Disruptions / year with Instana ',
  },
  label_2: {
    id: '/JLPR3',
    defaultMessage:
      '# Disruptions with accelerated resolution / year with Instana',
  },
  page_heading_5: {
    id: '+N8aiv',
    defaultMessage: 'Estimated IT efficiency improvements',
  },
  label_3: {
    id: 'yS8LA7',
    defaultMessage: 'Developer efficiency gains in less troubleshooting',
  },
  label_4: {
    id: 'fQq16y',
    defaultMessage: 'IT Ops efficiency gains in less troubleshooting',
  },
  label_6: {
    id: 'L9iZ+9',
    defaultMessage:
      'OpenSource technologies: Developer + IT Ops efficiency gains for monitoring setup and configuration',
  },
  page_heading_total: {
    id: 'wnBbas',
    defaultMessage: 'Estimated Total Developer + IT Ops efficiency gains',
  },
  footnote_2: {
    id: 'Pa5VCS',
    defaultMessage:
      'Instana is intended to provide a return on your investment by helping you streamline your application monitoring and disruption resolution processes. Estimates, including currency are current as of the initial date of publication and may be changed by IBM at any time and without notice.  Estimates are based on inputs provided and IBM internal results that assume: (1) hourly pay rate of $40 (USD) for developers and IT specialists and (2), where applicable, use of at least one open-source technology. It is the client’s responsibility to evaluate and verify the operation of any other products or programs with IBM Instana Observability. Generally expected results cannot be provided as each client’s results will depend entirely on the client’s systems and services ordered. Please contact IBM for a more precise personalized Business Value Assessment. Please note this is a generalized analysis. To find the value more aligned to your unique situation and business, complete the form to request a more personalized Business Value Assessment.',
  },
  export_to_pdf: {
    id: 'nqs1a4',
    defaultMessage: 'Export to PDF',
  },
  start_over: {
    id: '4prk89',
    defaultMessage: 'Start over',
  },
  charts_heading: {
    id: 'bM9JoJ',
    defaultMessage: 'Estimated Revenue Savings',
  },
  charts_label_1: {
    id: 'hgcXr5',
    defaultMessage:
      'In addition, through prevented disruptions / accelerated resolution with Instana, here are some possible top-line and/or bottom-line revenue savings as result of the improved application availability.',
  },
  chart_heading_summary: {
    id: 'p6EIck',
    defaultMessage: 'Your answer summary',
  },
  chart_label_summary_1: {
    id: '95tzlk',
    defaultMessage: 'Application disruptions per Month',
  },
  chart_label_summary_2: {
    id: 'lWkp/l',
    defaultMessage: 'Average time spent solving',
  },
  chart_label_summary_3: {
    id: 'dIxAfT',
    defaultMessage: 'Number of developers',
  },
  chart_label_summary_4: {
    id: 'GqZO1h',
    defaultMessage: 'Number of IT Ops employees',
  },
  chart_label_summary_5: {
    id: 'qW8CMI',
    defaultMessage: ' OpenSource technologies used',
  },
  contactUs: {
    id: 'WnQ/AZ',
    defaultMessage: 'Contact us',
  },
  ContactBP: {
    id: 'MsiLjH',
    defaultMessage: 'Contact IBM Business Partner',
  },
  'thankyou.title': {
    defaultMessage: 'Thank you!',
    id: 'aYIUar',
  },
  'thankyou.subtitle': {
    defaultMessage: 'We have received your request',
    id: 'PwjLGb',
  },
  'thankyou.details-title': {
    defaultMessage: 'Estimator details',
    id: 'n+lEbw',
  },
  'return-to-estimator': {
    defaultMessage: 'Take me back to BVA',
    id: '0D5mic',
  },
  foundCountry: {
    id: 'q0Y/L/',
    defaultMessage: 'Found country',
  },
  accessPage: {
    id: 'Z02o6s',
    defaultMessage: 'access page in',
  },
  accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  availableIn: {
    id: 'igQyQv',
    defaultMessage: 'The Turbonomic estimator is available in',
  },
  localCurrencie: {
    id: '35V5JI',
    defaultMessage: 'with local currency',
  },
  takeMeThere: {
    id: 'GeEQEA',
    defaultMessage: 'Take me there',
  },
  stayHere: {
    id: '4jk4C+',
    defaultMessage: 'No, thanks. Stay here',
  },
  question1: {
    id: '4jk4C+',
    defaultMessage: 'No, thanks. Stay here',
  },
  question2: {
    id: '4jk4C+',
    defaultMessage: 'No, thanks. Stay here',
  },
  question3: {
    id: '4jk4C+',
    defaultMessage: 'No, thanks. Stay here',
  },
  invalidVmText_1: {
    id: 'xK7hCb',
    defaultMessage: 'Maximum to process is',
  },
  invalidVmText_2: {
    id: 'xIWCOZ',
    defaultMessage: '. Please contact us',
  },
  invalidVmText_3: {
    id: 'U/FjKc',
    defaultMessage: 'Minimum to process is',
  },
  lessThan30MinsText: {
    id: 'uxU+2J',
    defaultMessage: 'Less than 30 mins',
  },
  thirtyNinetyMinsText: {
    id: 'jfya0B',
    defaultMessage: '30-90 mins',
  },
  hoursText: {
    id: 'j9Y9nu',
    defaultMessage: 'Hours',
  },
  daysPlusText: {
    id: 'gEX47n',
    defaultMessage: 'Days+',
  },
  pdfGenerated: {
    id: 'F9LZWa',
    defaultMessage: 'Your Export is being generated',
  },
  pdfCompleted: {
    id: 'zzXs9O',
    defaultMessage: 'Your Export is completed',
  },
  pdfError: {
    id: '2gydxl',
    defaultMessage: 'Your Export is incomplete',
  },
  downloadText: {
    id: '8qKRfT',
    defaultMessage: 'Download your document now',
  },
  pdfPara1: {
    id: 'Idoiae',
    defaultMessage:
      'Instana Enterprise Observability solution provides automated real-time application performance monitoring for IT Ops, DevOps, SRE and Development organizations.',
  },
  pdfPara2: {
    id: '5m79Jq',
    defaultMessage:
      'IBM Instana democratizes observability by providing a solution that anyone and everyone can use to get the data they want with the context they need. Instana automatically and continuously provides high fidelity data—1 second granularity and end-to-end traces—with the context of logical and physical dependencies across mobile, web, applications, and infrastructure.',
  },
  pdfPara3: {
    id: 'ku6Pml',
    defaultMessage:
      'The leader in cloud-native observability, Instana can manage legacy monolith and SOA applications as well, providing code-level visibility for 14 different languages. The only monitoring solution to tie applications and infrastructure together automatically, Instana delivers the understanding of what’s happening within application services without requiring subject matter experts to interpret what’s happening.',
  },
  pdfPara4: {
    id: '7SHFU9',
    defaultMessage:
      'Ultimately, this facilitates more efficient development and operations organizations, while helping to drive higher availability, improved performance, fewer incidents and happier customers.',
  },
  pdfPara5: {
    id: 'Vdx1xN',
    defaultMessage:
      'Below are the results from the Business Value Assessment you just completed.',
  },
  pdfPara6: {
    id: 'cWQ0Uv',
    defaultMessage:
      'To find a value more aligned to your unique situation and business, complete the form to request a more precise personalized Business Value Assessment',
  },
  pdfPara7: {
    id: 'ClRAqe',
    defaultMessage:
      'Instana is intended to provide a return on your investment by helping you streamline your application monitoring and disruption resolution processes. Estimates, including currency are current as of the initial date of publication and may be changed by IBM at any time and without notice. Estimates are based on inputs provided and IBM internal results that assume: (1) hourly pay rate of $40 (USD) for developers and IT specialists and (2), where applicable, use of at least one open-source technology. It is the client’s responsibility to evaluate and verify the operation of any other products or programs with IBM Instana Observability. Generally expected results cannot be provided as each client’s results will depend entirely on the client’s systems and services ordered.',
  },
  feedBackText: {
    id: 'XvuIXj',
    defaultMessage: 'Is this helpful:',
  },
  feddbackPhraseText: {
    id: 'yI2J2z',
    defaultMessage:
      'Please provide your thoughts about what we can do to better?',
  },
  feedbackComment: {
    id: '4FQrdH',
    defaultMessage: 'Comment:',
  },
  feedbackCommentHolder: {
    id: '6jv80B',
    defaultMessage: 'Your comments here...',
  },
  feedbackHeaderText: {
    id: 'qxui/f',
    defaultMessage: 'Feedback form',
  },
  feedbackInvalidMaximum: {
    id: '+uPBEM',
    defaultMessage: 'Maximum number of characters to process',
  },
  feedbackInvalidMinimum: {
    id: 'fkJa3C',
    defaultMessage: 'Minimum number of characters to process',
  },
  feedbackEmail: {
    id: 'zuu8pi',
    defaultMessage: 'Email (optional):',
  },
  feedbackEmailHolder: {
    id: 'Q75vbh',
    defaultMessage: 'Example: yourEmail@ibm.com',
  },
  feedbackInvalidEmail: {
    id: 'HBERi+',
    defaultMessage: 'Invalid email.',
  },
  feedbackCharacters: {
    id: '0Bc7rz',
    defaultMessage: 'Characters.',
  },
  feedbackCancel: {
    id: '47FYwb',
    defaultMessage: 'Cancel',
  },
  feedbackSubmit: {
    id: 'wSZR47',
    defaultMessage: 'Submit',
  },
  feedback203: {
    id: '7FTPXh',
    defaultMessage: 'Sorry, I could sent the feedback!',
  },
  feedback200: {
    id: 'FxvkF9',
    defaultMessage: 'Thank you! Your feedback was sent',
  },
  feedBackHelpfull: {
    id: '5vwKkg',
    defaultMessage: 'Helpful',
  },
  feedBackNotHelpfull: {
    id: '04tuTF',
    defaultMessage: 'Not helpful',
  },
  feedback500: {
    id: '4XFlJg',
    defaultMessage: 'Thank you, but something went wrong!',
  },
  modalResponseText: {
    id: 'MgdnPi',
    defaultMessage: 'Response',
  },
  modalContinue: {
    id: 'acrOoz',
    defaultMessage: 'Continue',
  },
  getQuoteButton2: {
    id: 'DXQb1r',
    defaultMessage: 'Get your best price',
  },
});
export default messages;
